import { Todo, TodoItem } from '@stratumn/atomic';

import PropType from 'prop-types';

const SignupStepper = ({ step }) => (
  <Todo>
    <TodoItem
      doing={step === 0}
      done={step > 0}
      label="Step 1"
      title="Create ID"
    />
    <TodoItem
      doing={step === 1}
      done={step > 1}
      label="Step 2"
      title="Generate keys"
    />
    <TodoItem
      doing={step === 2}
      done={step > 2}
      label="Step 3"
      title="Personalize account"
    />
  </Todo>
);

SignupStepper.propTypes = {
  step: PropType.number.isRequired
};

export default SignupStepper;
